module.exports = __webpack_public_path__ + "img/ghettotechtopia_title.2982b75f.png";